const BaseUrl = `https://aderawbackend.enatgames.com/`;
//const BaseUrl = `http://192.168.8.161:3008/`;
export default BaseUrl;
